import { Col, Row } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Board, Title } from './components';

const Leaderboard = ({}) => {
  const [data, setData] = useState([]);
  const leaderboard = useSelector((state) => state.shoutout?.leaderboard);
  const isMobile = useSelector((state) => state.appState.isMobile);

  useEffect(() => {
    const keys = Object.keys(leaderboard || {});
    if (!keys?.length) return setData([]);

    const renderData = keys
      .filter((key) => leaderboard[key]?.length)
      .map((key) => {
        return {
          title: `common.${key}`,
          data: leaderboard[key]
        };
      });

    setData(renderData);
  }, [leaderboard]);

  if (!data?.length || isMobile) return null;

  return (
    <Col noFlex bg={theme.GREY_10} wid="100%">
      <Row pad="24px 16px" gap="32px">
        {data.map((item, i) => (
          <Col noFlex wid="280px" key={i}>
            <Title title={item.title} isFirst={i === 0} />

            <Board data={item.data} />
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default Leaderboard;
